/**
 * Embedded-Modus (config.ini -> [Server] embedded_mode)
 *
 * Im Embedded-Modus entfaellt der App-Header; Hamburger-Menue, Mikrofon-Status,
 * Chat und Avatar ruecken in die Modul-Tab-Leiste.
 *
 * Der Wert kommt asynchron ueber /config/format. Damit der Header nicht bei
 * jedem Reload sichtbar umklappt, wird er in localStorage gecacht und beim
 * Modul-Import synchron als Startwert gelesen.
 */

import { useEffect, useState } from 'react';

const STORAGE_KEY = 'rd_embedded_mode';

const readCached = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (_) {
    return false;
  }
};

let embedded = readCached();
const subscribers = new Set();

export const isEmbeddedMode = () => embedded;

export const setEmbeddedMode = (value) => {
  const next = value === true;
  if (next === embedded) return;
  embedded = next;
  try {
    localStorage.setItem(STORAGE_KEY, next ? 'true' : 'false');
  } catch (_) {
    /* ignore */
  }
  subscribers.forEach((fn) => fn(next));
};

export const subscribeEmbeddedMode = (fn) => {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
};

export const useEmbeddedMode = () => {
  const [value, setValue] = useState(embedded);
  useEffect(() => {
    setValue(embedded);
    return subscribeEmbeddedMode(setValue);
  }, []);
  return value;
};
